import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const KEY = "rl_cookie_prefs_v1";

export default function CookieBanner() {
  const [open, setOpen] = useState(false);
  const [prefs, setPrefs] = useState({
    essential: true,
    analytics: false,
    marketing: false,
  });

  useEffect(() => {
    try {
      const stored = localStorage.getItem(KEY);
      if (!stored) setOpen(true);
    } catch (e) {
      setOpen(true);
    }
  }, []);

  const save = (p) => {
    try {
      localStorage.setItem(KEY, JSON.stringify({ ...p, ts: Date.now() }));
    } catch {}
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ y: 60, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 60, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          data-testid="cookie-banner"
          className="fixed inset-x-0 bottom-0 z-[60]"
        >
          {/* Editorial thin band, centered */}
          <div className="mx-auto max-w-[1280px] px-4 md:px-10 pb-4 md:pb-6">
            <div className="bg-white border border-[rgba(11,11,16,0.08)] shadow-[0_18px_44px_-18px_rgba(0,0,0,0.18)] rounded-full md:rounded-2xl flex flex-col md:flex-row md:items-center gap-4 md:gap-6 px-5 md:px-6 py-4 md:py-3.5">
              <div className="flex-1 min-w-0">
                <div className="font-editorial-mono text-[10.5px] text-[#5B2A86] mb-1">
                  COOKIES
                </div>
                <p className="text-[13px] leading-[1.5] text-[#4A4A55]">
                  We use essential cookies. Analytics &amp; marketing cookies help us improve — your call.
                </p>
              </div>
              <div className="flex items-center gap-3 md:gap-4 text-[11.5px]">
                {[
                  { k: "essential", label: "Essential", locked: true },
                  { k: "analytics", label: "Analytics" },
                  { k: "marketing", label: "Marketing" },
                ].map((row) => (
                  <label
                    key={row.k}
                    className="flex items-center gap-1.5 cursor-pointer text-[#0B0B10]"
                  >
                    <input
                      type="checkbox"
                      disabled={row.locked}
                      checked={prefs[row.k]}
                      onChange={(e) =>
                        setPrefs((p) => ({ ...p, [row.k]: e.target.checked }))
                      }
                      data-testid={`cookie-toggle-${row.k}`}
                      className="h-3.5 w-3.5 accent-[#5B2A86] cursor-pointer disabled:opacity-60"
                    />
                    <span className="font-editorial-mono">{row.label.toUpperCase()}</span>
                  </label>
                ))}
              </div>
              <div className="flex items-center gap-2">
                <button
                  data-testid="cookie-reject-all"
                  onClick={() => save({ essential: true, analytics: false, marketing: false })}
                  className="text-[12px] text-[#4A4A55] hover:text-[#0B0B10] px-3 py-2"
                >
                  Reject
                </button>
                <button
                  data-testid="cookie-save-prefs"
                  onClick={() => save(prefs)}
                  className="rounded-full border border-[rgba(11,11,16,0.15)] text-[#0B0B10] px-4 py-2 text-[12px] hover:border-[#5B2A86] hover:text-[#5B2A86] transition-colors"
                >
                  Save
                </button>
                <button
                  data-testid="cookie-accept-all"
                  onClick={() => save({ essential: true, analytics: true, marketing: true })}
                  className="rounded-full bg-[#0B0B10] text-white px-4 py-2 text-[12px] hover:bg-[#5B2A86] transition-colors"
                >
                  Accept all
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
